import axios from 'axios'
import { adminApiConfig, userConfig, webConfig } from '@base/configs'


export const adminChangePassword = axios.create({
  method: 'post',
  baseURL: `${webConfig.baseURL}/password/change/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getAdmin = axios.create({
  method: 'get',
  baseURL: `${userConfig.baseURL}/admin/`,
  headers: { 'Accept': 'application/json' },
})

export const updateAdmin = axios.create({
  method: 'patch',
  baseURL: `${userConfig.baseURL}/admin/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

// Market

export const getAdminMarket = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/markets/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const updateMarketSettings = axios.create({
  baseURL: `${adminApiConfig.baseURL}/markets/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const setTablePageSize = axios.create({
  method: 'patch',
  baseURL: `${adminApiConfig.baseURL}/markets/table_page_size/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const stripeConnect = axios.create({
  baseURL: `${adminApiConfig.baseURL}/stripe/connect/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const getLabelPrintSignature = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/label_print_signature/`,
  headers: { 'Accept': 'application/json' },
})

export const marketLogo = axios.create({
  baseURL: `${adminApiConfig.baseURL}/market_logo/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'multipart/form-data',
  }
})

export const deleteMarketImage = axios.create({
  method: 'delete',
  baseURL: `${adminApiConfig.baseURL}/images/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const createMarketImage = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/images/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'multipart/form-data',
  }
})

// Customer

export const getCustomer = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/customer/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const getCustomerList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/customers/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getAllCustomers = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/customers/summary/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const editCustomer = axios.create({
  baseURL: `${adminApiConfig.baseURL}/customers/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const addCustomer = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/customers/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const deleteCustomer = axios.create({
  method: 'delete',
  baseURL: `${adminApiConfig.baseURL}/customers/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const sendEmailConfirmation = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/send_email_confirmation/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const resetCustomerPassword = axios.create({
  method: 'patch',
  baseURL: `${adminApiConfig.baseURL}/reset_customer_password/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const verifyCustomer = axios.create({
  method: 'patch',
  baseURL: `${adminApiConfig.baseURL}/verify_customer/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

// Payments

export const getPaymentsInfo = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/payments_info/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getPaymentsInfoXLSX = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/payments_info/xlsx/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getCustomerPaymentReports = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/customer_payment_report/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})


export const getCustomerProductSalesReport = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/product_sales_report/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getBookingTransactionReport = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/booking_transaction_report/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

// Shelves

export const getShelfList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/shelves/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const editShelf = axios.create({
  method: 'put',
  baseURL: `${adminApiConfig.baseURL}/shelves/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const addShelf = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/shelves/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const deleteShelf = axios.create({
  method: 'delete',
  baseURL: `${adminApiConfig.baseURL}/shelves/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

// Booking periods

export const getBookingPeriodList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/booking_periods/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const editBookingPeriod = axios.create({
  method: 'put',
  baseURL: `${adminApiConfig.baseURL}/booking_periods/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const addBookingPeriod = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/booking_periods/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const deleteBookingPeriod = axios.create({
  method: 'delete',
  baseURL: `${adminApiConfig.baseURL}/booking_periods/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

// Additional services

export const getAdditionalServiceList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/additional_services/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const editAdditionalService = axios.create({
  method: 'put',
  baseURL: `${adminApiConfig.baseURL}/additional_services/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const addAdditionalService = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/additional_services/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const deleteAdditionalService = axios.create({
  method: 'delete',
  baseURL: `${adminApiConfig.baseURL}/additional_services/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

// Shelf types

export const getShelfTypeList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/shelf_types/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const editShelfType = axios.create({
  method: 'put',
  baseURL: `${adminApiConfig.baseURL}/shelf_types/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'multipart/form-data',
  }
})

export const addShelfType = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/shelf_types/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'multipart/form-data',
  }
})

export const deleteShelfType = axios.create({
  method: 'delete',
  baseURL: `${adminApiConfig.baseURL}/shelf_types/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const getShelfPeriodPriceList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/shelf_period_prices/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const getShelfPeriodPriceBookingEnd = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/shelf_period_prices/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const updateShelfPeriodPrice = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/shelf_period_prices/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const getShelfTypeServiceList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/shelf_type_services/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const updateShelfTypeService = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/shelf_type_services/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

// Closing days

export const updateMarketClosingDays = axios.create({
  method: 'put',
  baseURL: `${adminApiConfig.baseURL}/market_closing_days/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

// Booking requests

export const bookingRequests = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/booking_requests/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

// Campaigns

export const getCampaignList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/campaigns/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const editCampaign = axios.create({
  method: 'put',
  baseURL: `${adminApiConfig.baseURL}/campaigns/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const addCampaign = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/campaigns/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const deleteCampaign = axios.create({
  method: 'delete',
  baseURL: `${adminApiConfig.baseURL}/campaigns/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

// Shelf Bookings

export const getShelfBookingList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/shelf_bookings/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const editShelfBooking = axios.create({
  method: 'put',
  baseURL: `${adminApiConfig.baseURL}/shelf_bookings/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const addShelfBooking = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/shelf_bookings/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

export const deleteShelfBooking = axios.create({
  method: 'delete',
  baseURL: `${adminApiConfig.baseURL}/shelf_bookings/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

// Customer Bookings

export const getCustomerBookings = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/customer_bookings/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const salesPeriods = axios.create({
  baseURL: `${adminApiConfig.baseURL}/payments_info/sales_periods/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const bankExportTransactions = axios.create({
  baseURL: `${adminApiConfig.baseURL}/payments_info/bank_export_transactions/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const economicLayouts = axios.create({
  baseURL: `${adminApiConfig.baseURL}/economic_layouts/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const marketMessages = axios.create({
  baseURL: `${adminApiConfig.baseURL}/market_messages/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

// Reports

export const bookingsReport = axios.create({
  baseURL: `${adminApiConfig.baseURL}/bookings_report/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const customerCampaignsReport = axios.create({
  baseURL: `${adminApiConfig.baseURL}/customer_campaigns_report/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

// Product sheets

export const customerProductSheets = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/product_sheets/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const createCustomerProductSheet = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/product_sheets/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const updateCustomerProductSheet = axios.create({
  method: 'patch',
  baseURL: `${adminApiConfig.baseURL}/product_sheets/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const deleteCustomerProductSheet = axios.create({
  method: 'delete',
  baseURL: `${adminApiConfig.baseURL}/product_sheets/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})


// Products

export const getCustomerProductSaleLines = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/customer_product_sale_lines/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getCustomerProducts = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/customer_products/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const productsUpdate = axios.create({
  method: 'patch',
  baseURL: `${adminApiConfig.baseURL}/products/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const createCustomerProduct = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/product_sheets/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

// Product campaigns

export const productCampaigns = axios.create({
  baseURL: `${adminApiConfig.baseURL}/product_campaigns/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

// Balance Transactions

export const balanceTransactions = axios.create({
  baseURL: `${adminApiConfig.baseURL}/balance_transactions/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

// Subaccounts
export const customerSubaccounts = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/customers/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
})

// Customer Balance Report
export const getCustomerBalanceReport = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/customers/balance_report/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const exportCustomerBalanceReportPdf = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/customers/balance_report_export_pdf/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const exportCustomerBalanceReportXlsx = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/customers/balance_report_export_xlsx/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

// Manual Transactions Report
export const getManualTransactionsReport = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/manual_transactions_report/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

// Market Solo Products

export const getSoloProductList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/market_solo_products/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const addSoloProduct = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/market_solo_products/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const editSoloProduct = axios.create({
  method: 'put',
  baseURL: `${adminApiConfig.baseURL}/market_solo_products/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const deleteSoloProduct = axios.create({
  method: 'delete',
  baseURL: `${adminApiConfig.baseURL}/market_solo_products/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const reorderSoloProducts = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/market_solo_products/reorder/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

// Market Solo Categories (quick-add tabs on the register sale screen)

export const getSoloCategoryList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/market_solo_categories/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const addSoloCategory = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/market_solo_categories/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const editSoloCategory = axios.create({
  method: 'put',
  baseURL: `${adminApiConfig.baseURL}/market_solo_categories/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const deleteSoloCategory = axios.create({
  method: 'delete',
  baseURL: `${adminApiConfig.baseURL}/market_solo_categories/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const reorderSoloCategories = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/market_solo_categories/reorder/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getSoloPaymentMethodList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/market_solo_payment_methods/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const addSoloPaymentMethod = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/market_solo_payment_methods/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const editSoloPaymentMethod = axios.create({
  method: 'put',
  baseURL: `${adminApiConfig.baseURL}/market_solo_payment_methods/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const deleteSoloPaymentMethod = axios.create({
  method: 'delete',
  baseURL: `${adminApiConfig.baseURL}/market_solo_payment_methods/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const reorderSoloPaymentMethods = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/market_solo_payment_methods/reorder/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

// Market Solo VAT Product Groups (financial groups driving market product VAT)

export const getSoloVATGroupList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/market_solo_vat_groups/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const addSoloVATGroup = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/market_solo_vat_groups/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const editSoloVATGroup = axios.create({
  method: 'put',
  baseURL: `${adminApiConfig.baseURL}/market_solo_vat_groups/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const deleteSoloVATGroup = axios.create({
  method: 'delete',
  baseURL: `${adminApiConfig.baseURL}/market_solo_vat_groups/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

// Solo Sales (checkout / history / refund / receipt rendering)

export const getSoloSaleList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_sales/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getSoloSale = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_sales/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const createSoloSale = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/solo_sales/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const refundSoloSale = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/solo_sales/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const lookupSoloProduct = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_sales/lookup_product/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const soloPaymentMethodOptions = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_sales/payment_method_options/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const emailSoloReceipt = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/solo_sales/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const downloadSoloReceiptPdf = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_sales/`,
})

export const getSoloReceiptHtml = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_sales/`,
})

export const getSoloSaleTotals = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_sales/totals/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const downloadSoloCsv = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_sales/csv_export/`,
})

export const getSoloReceiptGiftCardsHtml = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_sales/`,
})

export const downloadSoloReceiptGiftCardsPdf = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_sales/`,
})

// Solo Gift Cards (report, lookup at the register, re-print / re-send)

export const getSoloGiftCardList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_gift_cards/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const lookupSoloGiftCard = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_gift_cards/lookup/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getSoloGiftCardVatReport = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_gift_cards/vat_report/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const downloadSoloGiftCardVatCsv = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_gift_cards/vat_report_csv/`,
})

export const getSoloGiftCardTotals = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_gift_cards/totals/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getSoloGiftCardHtml = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_gift_cards/`,
})

export const downloadSoloGiftCardPdf = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_gift_cards/`,
})

export const emailSoloGiftCard = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/solo_gift_cards/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const editSoloGiftCard = axios.create({
  method: 'patch',
  baseURL: `${adminApiConfig.baseURL}/solo_gift_cards/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const downloadSoloGiftCardsCsv = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_gift_cards/csv_export/`,
})

// Solo cash drawer (denominations, movements, X and Z reports)

export const getSoloCashDenominationList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/market_solo_cash_denominations/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const addSoloCashDenomination = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/market_solo_cash_denominations/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const deleteSoloCashDenomination = axios.create({
  method: 'delete',
  baseURL: `${adminApiConfig.baseURL}/market_solo_cash_denominations/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getSoloCashMovementList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_cash_movements/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const addSoloCashMovement = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/solo_cash_movements/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getSoloCashDrawer = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_cash_movements/drawer/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getSoloCashReportList = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_cash_reports/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getSoloCashReport = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_cash_reports/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const addSoloCashReport = axios.create({
  method: 'post',
  baseURL: `${adminApiConfig.baseURL}/solo_cash_reports/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getSoloCashReportPreview = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_cash_reports/preview/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

export const getSoloCashReportHtml = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_cash_reports/`,
})

export const downloadSoloCashReportPdf = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_cash_reports/`,
})

export const downloadSoloCashReportsCsv = axios.create({
  method: 'get',
  baseURL: `${adminApiConfig.baseURL}/solo_cash_reports/csv_export/`,
})
